import { RoleId } from '@wix/members-domain-ts';

import { APP_LOADED } from '../state/site/actions';
import { getBIAppData } from '../middleware/bi-events-middleware';
import { LEFT_COMMUNITY, JOINED_COMMUNITY } from '../state/community/actions';
import { SHOW_MODAL } from '../actions/show-modal';
import { getCurrentMemberId } from '../state/members/selectors';
import { getAppDefId } from '../state/site/selectors';
import { SET_PROFILE_SAVING } from '../state/profile-page/actions';
import { BI_FOLLOW_UNFOLLOW, MEMBERS_LIST_LAYOUT_CHANGE, OPEN_MEMBERS_CHAT } from '../state/members/actions';
import { MEMBERS_SEARCH, MEMBERS_SORT } from '../state/members-page/actions';
import { MERGE_GLOBAL_SETTING_IN_STORE, MERGE_COMPONENT_SETTING_IN_STORE } from '../actions/settings';
import { SHARE_URL } from '../constants/modal-types';
import { ROLES_ACTIONS_CLICK } from '../state/roles/actions';

export const eventMapUoU = {
  [APP_LOADED]: (action, state) => {
    const app = getBIAppData(state);
    return {
      evid: 814,
      origin: app.name,
      page_name: app.name,
      widget_id: app.id,
      widget_name: app.name,
    };
  },
  [SHOW_MODAL]: ({ payload }, state) => {
    const modals = {
      [SHARE_URL]: {
        evid: 807,
        member_chosen: getCurrentMemberId(state),
      },
      [RoleId.LEAVE_COMMUNITY]: { evid: 802 },
      [RoleId.JOIN_COMMUNITY]: { evid: 804 },
    };
    return modals[payload.type] || null;
  },
  [LEFT_COMMUNITY]: (action, state) => ({
    evid: 803,
    app_id: getAppDefId(state),
  }),
  [JOINED_COMMUNITY]: () => ({ evid: 805 }),
  [SET_PROFILE_SAVING]: ({ isSaving, changed }) => (isSaving ? { evid: 815, ...changed } : null),
  [BI_FOLLOW_UNFOLLOW]: ({ isFollowed, actingOn }, state) => ({
    evid: 810,
    is_followed: isFollowed ? 1 : 0,
    member_followed: actingOn,
    origin: getBIAppData(state).name,
  }),
  [MEMBERS_SEARCH]: ({ payload }) => ({
    evid: 813,
    search_term: payload || '',
  }),
  [MEMBERS_SORT]: ({ payload }) => ({ evid: 812, sort_by: payload || '' }),
  [ROLES_ACTIONS_CLICK]: ({ memberId, roleId, formOrigin }) => ({
    evid: 811,
    member_chosen: memberId,
    action_type: roleId,
    formOrigin,
  }),
  [OPEN_MEMBERS_CHAT]: ({ messagedMemberId }, state) => ({
    evid: 817,
    messaged_member_id: messagedMemberId,
    origin: getBIAppData(state).name,
  }),
  [MEMBERS_LIST_LAYOUT_CHANGE]: ({ layoutType }) => ({
    evid: 867,
    layout_type: layoutType,
  }),
};

export const eventMapUsers = {
  [APP_LOADED]: (action, state) => ({
    evid: 902,
    settings_changed: 0,
    origin: getBIAppData(state).name,
  }),
  [MERGE_GLOBAL_SETTING_IN_STORE]: ({ payload }, state) => {
    if (payload.showFollowers !== undefined) {
      return { evid: 901, origin: getBIAppData(state).name };
    }
  },
  [MERGE_COMPONENT_SETTING_IN_STORE]: ({ payload }) => {
    if (payload.guestsAllowed !== undefined) {
      return { evid: 903, login_required: payload.guestsAllowed ? 0 : 1 };
    }
  },
};
